import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "redact-a-pdf",
  courseId: "forms",
  order: 7,
  title: "Redact a PDF",
  summary:
    "For a records request or discovery packet, upload the PDF, let the AI find the PII, adjust the boxes, and export a true redaction that cannot be undone.",
  learn: [
    "Upload a document and run identification",
    "Add, remove, and find-and-redact by hand",
    "Export a rasterized redacted PDF with tags and footnotes",
  ],
  minutes: 5,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "**Redactions** in the sidebar is for whole documents: records requests, discovery, press releases. Redacting text inside a narrative is a separate feature in the editor's **Redactions** panel.",
    },
    {
      type: "steps",
      items: [
        "Click **Redactions**, then **Upload PDF**.",
        "In \"Upload Document to Redact\", set a Document Name and optional Redaction Instructions (\"redact juvenile names and all addresses\"), then click **Upload & Redact**.",
        "Wait for the status to move from Identifying PII... to Redacted, then open the document.",
        "Review each proposed box. Use Select to move or delete one, **Redact Text** to draw over a text run, and **Redact Box** for a free area such as a photo or signature.",
        "Click **Find & Redact** to search a term and redact one match or every match. **Re-identify** reruns the AI with new instructions.",
        "Click **Add tag** on each redaction, and add a footnote with the legal basis (\"+ Add footnote...\").",
        "Click **Save**, then **Export**, then **Agree and export redacted PDF**.",
      ],
    },
    {
      type: "paragraph",
      text: "Snap to guides, View labels on bars, and Standard text size are toggles that affect how the export looks. With labels on bars, each black bar prints its tag (for example \"DOB\").",
    },
    {
      type: "callout",
      tone: "warning",
      title: "The export is permanent",
      text: "Exported pages are rasterized, so the redacted text is gone, not hidden under a box. The original stays in the app, and you can come back and export again with different boxes.",
    },
    {
      type: "paragraph",
      text: "To redact a narrative before it leaves the app, see the export options in Export your report.",
    },
  ],
  related: ["export-your-report", "the-files-library"],
};

export default lesson;
